import { css } from "@emotion/css";
import { CheckboxRenderProps } from "react-aria-components";

import { Icon } from "../../../../foundations/icons/Icon/Icon";
import { useColors } from "../../../../hooks/useColors";

interface Props extends Partial<CheckboxRenderProps> {}

export function _CheckboxAsset(props: Props) {
  const colors = useColors();
  const {
    isSelected,
    isIndeterminate,
    isDisabled,
    isFocusVisible,
    isHovered,
    isFocused,
  } = props;

  return (
    <div className={styles.container}>
      <div
        className={css(
          styles.checkbox,
          isHovered && {
            borderColor: "var(--border-input-hover)",
          },
          isFocused && {
            boxShadow: "var(--focus-action)",
          },
          isSelected && {
            borderWidth: 0,
            backgroundColor: "var(--background-selected-strong)",
          },
          isIndeterminate && {
            borderWidth: 0,
            backgroundColor: "var(--background-selected-strong)",
          },
          isDisabled &&
            css(
              {
                cursor: "not-allowed",
                borderColor: "var(--border-input-disabled)",
              },
              (isSelected || isIndeterminate) && {
                backgroundColor: "var(--border-input-disabled)",
              }
            ),
          isFocusVisible && {
            boxShadow: "var(--focus-action)",
          }
        )}
      >
        {!isIndeterminate && isSelected && (
          <Icon
            name="check"
            color="icon-inverse"
            type="mini"
            testID="checked-icon-wrapper"
          />
        )}
        {isIndeterminate && (
          <svg
            width="18"
            height="18"
            viewBox="0 0 18 18"
            fill={colors["icon-inverse"]}
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M4 9C4 8.44772 4.44772 8 5 8H13C13.5523 8 14 8.44772 14 9C14 9.55228 13.5523 10 13 10H5C4.44772 10 4 9.55228 4 9Z" />
          </svg>
        )}
      </div>
    </div>
  );
}

const styles = {
  container: css({
    alignItems: "center",
    display: "flex",
    flexShrink: 0,
    height: 20,
    justifyContent: "center",
    width: 20,
  }),
  checkbox: css({
    alignItems: "center",
    borderRadius: "var(--border-radius-2)",
    borderStyle: "solid",
    borderWidth: 2,
    boxSizing: "border-box",
    display: "flex",
    height: 18,
    justifyContent: "center",
    width: 18,
    borderColor: "var(--border-input)",
  }),
};
